import { render } from "./KbButton.vue?vue&type=template&id=5f29db7c&scoped=true"
import script from "./KbButton.vue?vue&type=script&lang=js"
export * from "./KbButton.vue?vue&type=script&lang=js"

import "./KbButton.vue?vue&type=style&index=0&id=5f29db7c&scoped=true&lang=css"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f29db7c"]])

export default __exports__